import { makeStyles } from "@mui/styles";
export const useStyles = makeStyles((theme) => ({
	customLink: {
		textTransform: "none",
		color: theme.palette.text.primary,
		fontSize: "1rem",
		fontWeight: 500,
		width: theme.fullWidth.width,
		textDecoration: "underline",
		borderWidth: 0,
		whiteSpace: "nowrap",
	},
	customButton: {
		textTransform: "none",
		fontSize: "0.875rem",
		fontWeight: 500,
		lineHeight: 1.75,
		borderRadius: theme.shape.borderRadius,
		width: theme.fullWidth.width,
		whiteSpace: "nowrap",
	},
	contained: {
		color: `${theme.palette.custom.searchResults.manualReceive.color} !important`,
		backgroundColor: theme.palette.primary.main,
	},
	outlined: {
		color: theme.palette.text.primary,
		border: `1px solid ${theme.palette.text.primary}`,
	},
}));
